import {
  type ChangeEventHandler,
  type DetailedHTMLProps,
  type ForwardRefRenderFunction,
  forwardRef,
  type InputHTMLAttributes,
} from 'react'

import { LabelWrapper } from '../Select/style'
import { InputStyled, LabelStyled } from './styles'

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

interface RadioProps extends InputProps {
  value: string
  name: string
  label: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  labelAdornment?: React.ReactNode
  disabled?: boolean
}

const RadioComponent: ForwardRefRenderFunction<HTMLInputElement, RadioProps> = (
  { value, name, label, labelAdornment, disabled, onChange, ...rest },
  ref,
) => {
  return (
    <LabelWrapper>
      <LabelStyled disabled={disabled}>
        <InputStyled
          data-testid="radio-component"
          disabled={disabled}
          name={name}
          onChange={onChange}
          ref={ref}
          type="radio"
          value={value}
          {...rest}
        />
        {label}
      </LabelStyled>
      {labelAdornment && <>{labelAdornment}</>}
    </LabelWrapper>
  )
}

export const Radio = forwardRef(RadioComponent)
